import { useMalware } from "../../../context/Dashboard/contextMalware";
import { useThemeMode } from "../../../context/contextTheme";
import { useRef, useState } from "react";

const FileForm = () => {
  const { malScanLoading, handleFileScan } = useMalware();
  const { theme } = useThemeMode();
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [isScanning, setIsScanning] = useState(false); // Track local execution lifecycle

  const onPick = () => {
    if (!malScanLoading && !isScanning && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const onChange = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFileName(f.name);
    setIsScanning(true);

    try {
      await handleFileScan(f);
    } catch (error) {
      console.error("Malware file dispatch error:", error);
    } finally {
      setIsScanning(false);
      e.target.value = "";
    }
  };

  const globalLoadingState = malScanLoading || isScanning;
  const surface = {
    backgroundColor: theme.cardBg ?? theme.background,
    border: `1px dashed ${theme.border}`,
    color: theme.textColor,
  };

  return (
    <div className="fade-in">
      <div
        className="rounded-4 d-flex align-items-center justify-content-center flex-column text-center p-4"
        style={{ ...surface, minHeight: 140, height: 280 }}
      >
        <i 
          className={`bi ${globalLoadingState ? 'bi-shield-fill-exclamation text-danger animate-pulse' : 'bi-file-earmark-break-fill'} mb-2`} 
          style={{ fontSize: "3.5rem", color: globalLoadingState ? theme.primary : theme.textMuted, transition: 'all 0.3s ease' }} 
        />
        <div className="mb-2 fw-semibold" style={{ color: theme.textColor }}>
          {globalLoadingState ? "Analyzing file payload safely..." : "Upload a file to scan (Max 650MB)"}
        </div>
        <div className="small mb-3" style={{ color: theme.textMuted }}>
          Supported: archives, docs, scripts, executables, text, and more
        </div>

        <div className="d-flex flex-column gap-2 align-items-center">
          <button
            className="btn fw-semibold d-flex align-items-center justify-content-center gap-2"
            style={{
              minWidth: 180,
              color: theme.textColorInv,
              backgroundColor: globalLoadingState ? theme.textMuted : theme.secondary,
              borderRadius: 10,
              transition: "all 0.2s ease"
            }}
            onClick={onPick}
            disabled={globalLoadingState}
          >
            {globalLoadingState ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Scanning Asset...
              </>
            ) : (
              "Choose File"
            )}
          </button>
          
          {fileName && (
            <span className="small mt-1 px-2 py-1 rounded bg-light text-truncate" style={{ color: theme.textMuted, maxWidth: "250px" }}>
              <i className="bi bi-paperclip me-1"></i>{fileName}
            </span>
          )}
        </div>

        <input
          type="file"
          ref={fileInputRef}
          onChange={onChange}
          style={{ display: "none" }}
          aria-label="Upload file for malware scan"
          accept={[
            ".exe",".zip",".rar",".pdf",".doc",".docx",".xls",".xlsx",
            ".js",".jsx",".ts",".tsx",".py",".sh",".rb",".pl",
            ".bat",".cmd",".vbs",".php",".html",".css",
            ".json",".xml",".csv",".txt"
          ].join(",")}
        />
      </div>
    </div>
  );
};

export default FileForm;